module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.e72f1492.jpg";